import { useQueries } from '@tanstack/react-query';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { ModuleType } from 'infrastructure/enums';
import QueryParams from 'utils/queryParams';

import { getKeyNotes } from './api/getKeyNoteFn';

interface Props {
  patientGuid?: string;
  module: ModuleType;
  canChangeModule?: boolean;
  showExpired?: boolean;
}
export const getKeyNoteKey = ({ patientGuid, module, showExpired }: Props) => [
  'getKeyNoteData',
  patientGuid,
  module,
  showExpired,
];

export const useGetKeyNote = ({
  patientGuid,
  module,
  canChangeModule,
  showExpired,
}: Props) => {
  const apiUrl = API_PATIENT_KEY_NOTE(patientGuid);

  const urlRPM = QueryParams.stringifyUrl(apiUrl, {
    module: ModuleType.RPM,
    showExpires: showExpired,
  });
  const urlCCM = QueryParams.stringifyUrl(apiUrl, {
    module: ModuleType.CCM,
    showExpires: showExpired,
  });

  const [rpmQueryData, ccmQueryData] = useQueries({
    queries: [
      {
        queryKey: getKeyNoteKey({
          patientGuid,
          module: ModuleType.RPM,
          showExpired,
        }),
        queryFn: () =>
          getKeyNotes({
            url: urlRPM,
          }),
        enabled:
          (canChangeModule || module === ModuleType.RPM) &&
          Boolean(patientGuid),
      },
      {
        queryKey: getKeyNoteKey({
          patientGuid,
          module: ModuleType.CCM,
          showExpired,
        }),
        queryFn: () =>
          getKeyNotes({
            url: urlCCM,
          }),
        enabled:
          (canChangeModule || module === ModuleType.CCM) &&
          Boolean(patientGuid),
      },
    ],
  });
  return [rpmQueryData, ccmQueryData];
};
